import { render, staticRenderFns } from "./review-grid-kind-lokal.vue?vue&type=template&id=999a8c56&scoped=true&"
import script from "./review-grid-kind-lokal.vue?vue&type=script&lang=js&"
export * from "./review-grid-kind-lokal.vue?vue&type=script&lang=js&"
import style0 from "./review-grid-kind-lokal.vue?vue&type=style&index=0&id=999a8c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999a8c56",
  null
  
)

export default component.exports